import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHouse = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 6L7.5 9M14.5 6V12L7.5 15M14.5 6L11 1L4 4M7.5 9V15M7.5 9L4 4M7.5 15L0.5 12V6L4 4M2.5 13V9.75L5.5 11V14",
		stroke: "currentColor",
		strokeOpacity: .8,
		strokeLinejoin: "round"
	})
});
export default SvgIconHouse;
